import styled from 'styled-components'
import { theme } from '@mtsdengi/ui-kit'
import { unAuthTheme } from '@mtsdengi/common'

type TWrapperProps = {
  isHidden: boolean
  bottomValue?: number
}

const Wrapper = styled.div<TWrapperProps>`
  background: ${theme.colors.neutral.g800}e0;
  position: fixed;
  bottom: ${({ isHidden, bottomValue = unAuthTheme.bottomMenuHeight }) =>
    isHidden
      ? `calc(${-theme.spacings.xl3 - 1}px - env(safe-area-inset-bottom))`
      : `calc(${bottomValue}px + env(safe-area-inset-bottom))`};

  left: 0;
  z-index: ${theme.z_indexes.med};
  width: 100%;
  padding: ${theme.spacings.xs2}px ${theme.spacings.xs}px;
  transition: bottom ${theme.transitions.basic};
`

export const Styled = { Wrapper }
